import { BettingStructure } from '@repo/database/src/types';

export enum StakeName {
  MICRO = 'Micro',
  LOW = 'Low',
  MEDIUM = 'Medium',
  HIGH = 'High',
}

export interface StakeOptionFilter {
  bettingStructure: BettingStructure;
  min: number;
  max: number | undefined;
  minInclusive?: boolean;
  maxInclusive?: boolean;
}
